/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiAPlayForwardIcon16Solid = forwardRef('MediaUiAPlayForwardIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "m8.515 2.255 6.354 4.433a1.6 1.6 0 0 1 0 2.624l-6.354 4.433C7.455 14.485 6 13.726 6 12.433V3.567c0-1.293 1.455-2.052 2.515-1.312Z" }),
        React.createElement("path", { d: "M4 3a1 1 0 1 0-2 0v10a1 1 0 1 0 2 0V3Z" })));
});
